import { assignOrderRelatedData } from '../../../utils';
export const onCompletedOrderLoadSuccess = (response, cacheDuration) => {
    const { order, relatedData } = response;
    assignOrderRelatedData(relatedData, cacheDuration);
    return order;
};
//# sourceMappingURL=on-completed-order-load-success.js.map